import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Auth.css';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { forgotPassword } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    setLoading(true);
    const result = await forgotPassword(email.trim());
    setLoading(false);
    if (result.success) {
      setMessage(result.message);
    } else {
      setError(result.error);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-brand">
          <img src="/tradelensy-logo.png" alt="Tradelensy logo" className="auth-logo" />
          <h1>Tradelensy</h1>
        </div>
        <h2>Forgot password</h2>
        <p style={{ color: '#666', lineHeight: 1.5, marginBottom: '16px' }}>
          Enter your email. If an account exists, we will send a link to reset your password.
        </p>
        {error && <div className="error-message">{error}</div>}
        {message && (
          <div
            style={{
              padding: '12px',
              borderRadius: '4px',
              background: '#d4edda',
              color: '#155724',
              fontSize: '14px',
              marginBottom: '16px',
            }}
          >
            {message}
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
            />
          </div>
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Sending…' : 'Send reset link'}
          </button>
        </form>
        <p className="auth-link">
          <Link to="/login">Back to login</Link>
        </p>
      </div>
    </div>
  );
}

export default ForgotPassword;
